import API from './axios.js';

export const getAllExistPlans = (queryParams='') => API.get(`super-admin/plans${queryParams}`);
export const getExistPlanByID = (id) => API.get(`super-admin/plans/${id}`);
export const addPlan = (data) => API.post(`super-admin/plans`,data);
export const updatePlan = (id,payload) => API.put(`super-admin/plans/${id}`,payload);
export const deletePlan = (id) => API.delete(`super-admin/plans/${id}`);


export const companyaddeditcourtdetails = (id,payload) => API.post(`super-admin/company/court-details/${id}`,payload);



export const getAllUsersForSuperAdmin = (queryParams= '') => API.get(`super-admin/user${queryParams}`);
export const addUserBySuperAdmin = (data) => API.post(`super-admin/user`,data);
export const updateUserBySuperAdmin = (id,payload) => API.put(`super-admin/user/${id}`,payload);
export const deleteUserBySuperAdmin = (id) => API.delete(`super-admin/user/${id}`);



export const getAllCompaniesForSuperAdmin = (queryParams='') => API.get(`super-admin/company${queryParams}`);
export const getCompanyByID = (company_id) => API.get(`company/${company_id}`);
export const addCompanyBySuperAdmin = (payload) => API.post(`super-admin/company`,payload);
export const updateCompanyBySuperAdmin = (id,payload) => API.put(`super-admin/company/${id}`,payload);
export const deleteCompany = (id) => API.delete(`super-admin/company/${id}`);

export const hcScrapingSync = (id) => API.get(`scraper/high-court/by-company/${id}`);
export const getHcScrapingStatus = () => API.get(`super-admin/company/hc-scraping-status`);


export const dcScrapingSync = (id) => API.get(`scraper/district-court/by-company/${id}`);
export const getDcScrapingStatus = () => API.get(`super-admin/company/dc-scraping-status`);



export const SearchGetAllExistPlans = (input) => API.get(`super-admin/plans?search=${input}`);
export const SearchGetAllUsersForSuperAdmin = (input) => API.get(`super-admin/user?search=${input}`);
export const SearchGetAllCompaniesForSuperAdmin = (input) => API.get(`super-admin/company?search=${input}`);

export const getPlanRightsByID = (id) => API.get(`super-admin/plans/${id}`);
export const getAllRightsEdit = (company_id) => API.get(`super-admin/company-rights/${company_id}`);

export const getUserRightsEdit = (user_id) => API.get(`super-admin/user-rights/${user_id}`);

export const createPaymentOrder = (planId, companyId) => API.get(`payment/order?planId=${planId}&companyId=${companyId}`);

export const getCustomRights = (companyId) => API.get(`super-admin/rights-override/${companyId}`);

export const createOrUpdateCustomRights = (payload) => API.put(`super-admin/rights-override`,payload);


export const createSystemInvoice = (payload) => API.post(`super-admin/system-invoice`, payload);

export const getSystemSettings = () => API.get(`super-admin/system-settings`);

export const incrementInvoiceNumber = () => API.patch(`super-admin/system-settings/increment/invoice`);

export const incrementReceiptNumber = () => API.patch(`super-admin/system-settings/increment/receipt`);

export const addPaymentToSystemInvoice = (invoiceId, payload) => API.patch(`super-admin/${invoiceId}/system-invoice/add-payment`, payload);

export const getSystemInvoicesByCompany = (companyId) => API.get(`super-admin/system-invoice-by-companies/${companyId}`);

export const updateSystemInvoiceStatus = (invoiceId, status, cancelRemark = '') => {
  const params = new URLSearchParams({ status });
  if (status === 'cancelled' && cancelRemark) {
    params.append('cancelRemark', cancelRemark);
  }
  return API.patch(`super-admin/system-invoice-status/${invoiceId}?${params.toString()}`);
};

export const getLoginLogsByCompany =(companyId) => API.get(`login-logs/${companyId}`);

export const loginUserWithSuperAdmin = (companyId) => API.get(`auth/super-admin-login/${companyId}`);

export const maharashtraScrapingSync = (companyId) => API.post(`super-admin/scrape/hc/maharashtra/${companyId}`)

export const gujaratScrapingSync = (companyId) => API.post(`super-admin/scrape/hc/gujarat/${companyId}`)

export const scScrapingSync = (companyId) => API.post(`super-admin/scrape/sc/${companyId}`)

export const getScScrapingStatus = () => API.get(`super-admin/company/sc-scraping-status`)

export const getSupremeCourtFetchedManageCases = (companyId, queryParams = '') => API.get(`case/manage-cases/sc/fetched/${companyId}${queryParams}`)
export const getSupremeCourtAddedManageCases = (companyId, queryParams = '') => API.get(`case/manage-cases/sc/added/${companyId}${queryParams}`)
export const UpdateSCFetchedManagedCases = (companyId, payload) => API.patch(`case/supreme-court/fetched-cases/selection/${companyId}`, payload)
export const UpdateSCAddedManagedCases = (companyId, payload) => API.patch(`case/supreme-court/added-cases/selection/${companyId}`, payload)